import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'lib-input-switch',
  templateUrl: './ui-input-switch.component.html',
  styleUrl: './ui-input-switch.component.scss',
})
export class UiInputSwitchComponent {
  @Input() id = '';
  @Input() label = '';
  @Input() legend = '';
  @Input() description = '';
  @Input() disabled = false;
  @Input() control?: AbstractControl | null;

  get formControl(): FormControl<boolean> | null {
    return this.control instanceof FormControl
      ? (this.control as FormControl<boolean>)
      : null;
  }

  get isChecked(): boolean {
    return !!this.formControl?.value;
  }

  onChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const checked = target.checked;

    if (this.formControl) {
      this.formControl.setValue(checked);
      this.formControl.markAsDirty();
      this.formControl.markAsTouched();
    }
  }

}
